import { Text } from '@consta/uikit/Text'
import { GroupingHeader } from '@core/components'
import type { FC } from 'react'

import type { GeometryMenuProps } from '../types'
import css from './VelocitySimulationRightMenu.css'

export const GeometryMenu: FC<GeometryMenuProps> = ({ modelResults, chosenVelocityModel }) => {
  const rowMapper = [
    [
      {
        label: 'Мин X',
        value: () => {
          if (modelResults) {
            return modelResults.xMin
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.xMin
          }
          return 0
        },
      },
      {
        label: 'Мин Y',
        value: () => {
          if (modelResults) {
            return modelResults.yMin
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.yMin
          }
          return 0
        },
      },
    ],
    [
      {
        label: 'Макс X',
        value: () => {
          if (modelResults) {
            return modelResults.xMax
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.xMax
          }
          return 0
        },
      },
      {
        label: 'Макс Y',
        value: () => {
          if (modelResults) {
            return modelResults.yMax
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.yMax
          }
          return 0
        },
      },
    ],
    [
      {
        label: 'Δ X',
        value: () => {
          if (modelResults) {
            return modelResults.stepX
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.xMax - chosenVelocityModel.xMin
          }
          return 0
        },
      },
      {
        label: 'Δ Y',
        value: () => {
          if (modelResults) {
            return modelResults.stepY
          } else if (chosenVelocityModel) {
            return chosenVelocityModel.yMax - chosenVelocityModel.yMin
          }
          return 0
        },
      },
    ],
  ]

  const ResultBox = rowMapper.map((rows, index) => (
    <div key={index} className={css.modelMenuResultsGridRow}>
      {rows.map((row, index) => (
        <div key={index} className={css.modelMenuResultsGridItem}>
          <Text size="xs" view="secondary" className={css.modelMenuResultsGridRowText}>
            {row.label}
          </Text>
          <Text size="xs" view="primary">
            {(modelResults ?? chosenVelocityModel) ? row.value().toFixed(1) : 0}
          </Text>
        </div>
      ))}
    </div>
  ))

  return (
    <>
      <GroupingHeader title="Геометрия" />
      <div className={css.modelMenuResultsGrid}>{ResultBox}</div>
    </>
  )
}
